import { Skeleton } from '@loop3/ui'

/** Header-plus-grid placeholder shared by the Explorer detail pages. */
export function DetailSkeleton() {
  return (
    <div className="mx-auto max-w-7xl pb-16">
      <div className="mb-6 mt-2 border-b border-border pb-6">
        <Skeleton className="h-3 w-16" />
        <div className="mt-3 flex items-center gap-3">
          <Skeleton className="size-10 rounded-xl" />
          <Skeleton className="h-8 w-64" />
        </div>
        <Skeleton className="mt-3 h-3 w-80 max-w-full opacity-60" />
        <div className="mt-4 flex gap-2">
          <Skeleton className="h-6 w-28 rounded-full" />
          <Skeleton className="h-6 w-24 rounded-md" />
        </div>
      </div>
      <Skeleton className="mb-3 h-3 w-28" />
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-[74px] rounded-xl" />
        ))}
      </div>
    </div>
  )
}
